
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event-actor/[[...slug]]",
      function () {
        return require("private-next-pages/event-actor/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/event-actor/[[...slug]]"])
      });
    }
  